const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};
const fixMainCart = () => {
  if (BSS_B2B) {
    const debouncedFixer = debounce(() => {
      console.log("A child node has been added or removed.");
      BSS_B2B.cart.fixer(
        JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),
        false,
        false
      );
    }, 300);
    const targetNode = document.querySelector(".cart");
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "requires-shipping"
        ) {
          $(".bss-qb-price-item").remove();
          BSS_B2B.cart.fixer(
            JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),
            false,
            false
          );
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
};

const fixCartDrawer = () => {
  const element = document.querySelector("#cart-drawer");
  if (BSS_B2B && element) {
    const debouncedFixer = debounce(() => {
      BSS_B2B.cart.fixer(
        JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),
        false,
        true
      );
    }, 300);

    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          element.className.includes("is-open")
        ) {
          debouncedFixer();
        }
      }
    });

    observer.observe(element, { attributes: true, attributeFilter: ["class"] });
  }
};

window.onload = () => {
  if (window.location.pathname == "/cart") {
    setTimeout(() => {
      const qbPrice = document.querySelector(".bss-qb-price-item");
      if (qbPrice) {
        qbPrice.textContent = qbPrice.textContent + " ea";
      }
    }, 2000);
  }
};
if (
  window.location.pathname.includes("/products") &&
  typeof BSS_B2B !== "undefined"
) {
  let interval = setInterval(() => {
    const wrapper = $(
      ".product__submit__holder.product__submit__holder--notification > .custom_qty"
    );
    const qbTitle = $(".bss-b2b-cart-item-qty-table-header-title");
    if (wrapper.length > 0 && qbTitle.length > 0) {
      clearInterval(interval);
      qbTitle.css("display", "block");
      qbTitle.css("marginTop", "0");
      qbTitle.css("marginLeft", "4px");
      qbTitle.appendTo(wrapper);
      $(".bss-b2b-qty-table-row[data-min=50]").click();
    }
  }, 50);
  setTimeout(() => {
    clearInterval(interval);
  }, 6000);
}
document.addEventListener("DOMContentLoaded", (event) => {
  if (window.location.pathname == "/cart") {
    fixMainCart();
  }
  fixCartDrawer();
});
